/**
 * Typed tRPC instance for the learn app (SCH Milestone A).
 *
 * Same pattern as `apps/admin/src/lib/trpc.ts` — `AppRouter` comes from
 * `@mangrove/api-contract` (the generated self-contained rollup of the
 * api's router declaration; see ADR-0058). It's a leaf package and the
 * import is type-only, so neither the bundler nor `turbo prune` pulls
 * the backend (api/core/db) into this SPA.
 */
import type { AppRouter } from '@mangrove/api-contract';
import { createPosTrpcReact, type PosTrpcReact } from '@mangrove/trpc-client/react';

export type { AppRouter };

// Explicit annotation needed because `@trpc/react-query` is hoisted under
// `@mangrove/trpc-client/node_modules` — without `PosTrpcReact<AppRouter>`
// here, TS would inline a non-portable path into the inferred type.
export const trpc: PosTrpcReact<AppRouter> = createPosTrpcReact<AppRouter>();
